import { selectTerritoryLicensingLimits } from '@/features/domain/territory'
import { selectUserType } from '@/features/domain/user'
import { useSelector } from 'react-redux'

export function usePlanningRange() {
  const userType = useSelector(selectUserType)
  const { planningRange } = useSelector(selectTerritoryLicensingLimits)
  const canEditPlanningRange = ['admin', 'planner'].includes(userType)

  return {
    planningRange,
    canEditPlanningRange,
  }
}
